<template>
  <div>
    <el-input 
              size="small"
              placeholder="搜索"
              v-model="search"></el-input>
    <el-button type="primary"
               @click="setname">查询</el-button>
  </div>

</template>

<script>
export default {
  data () {
    return {
      search: ""
    }
  },
  props: ['getname'],
  methods: {
    setname () {
      this.getname(this.search)
      this.$parent.search()
      console.log("chufa");
    },
		clear(){
			this.search=''
		}
  }
}
</script>

<style lang="less" scoped>
div {
  display: flex;
  align-items: center;
  .el-input {
    margin-right: 20px;
    width: 150px;
  }
}

</style>